import RefundConsents from '@/components/refund/RefundConsents';
import { TransText } from '@/i18n/trans/text';
import { breakpoints } from '@/utils/breakpoints';
import { Button, Icons } from '@packages/webshop-design-system';
import { type FC, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

interface RefundModalOverviewFooterProps {
  handleBackToSelection: () => void;
  handleConfirmRefund: () => void;
  loading: boolean;
}

const RefundModalOverviewFooter: FC<RefundModalOverviewFooterProps> = ({
  handleBackToSelection,
  handleConfirmRefund,
  loading,
}) => {
  const [consentsAccepted, setConsentsAccepted] = useState(false);
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });

  return (
    <div className="flex w-full flex-col gap-2">
      <RefundConsents onAcceptanceChange={setConsentsAccepted} />
      <div className="flex gap-2 laptop:justify-end">
        <Button
          variant="tertiary"
          data-testid="back-btn"
          onClick={handleBackToSelection}
          className="rounded-lg laptop:w-auto"
          size={isLaptopOrBigger ? 'regular' : 'large'}
          startAdornment={
            <Icons.arrowLeft
              height={isLaptopOrBigger ? 16 : 24}
              width={isLaptopOrBigger ? 16 : 24}
            />
          }
        >
          <TransText i18nKey="back" />
        </Button>
        <Button
          data-testid="confirm-refund-btn"
          onClick={handleConfirmRefund}
          isDisabled={!consentsAccepted}
          isPending={loading}
          className="rounded-lg laptop:w-auto"
          size={isLaptopOrBigger ? 'regular' : 'large'}
          startAdornment={
            <Icons.ticketReturn
              height={isLaptopOrBigger ? 16 : 24}
              width={isLaptopOrBigger ? 16 : 24}
            />
          }
        >
          <TransText i18nKey="confirm" />
        </Button>
      </div>
    </div>
  );
};

export default RefundModalOverviewFooter;
